import React from 'react';
import { ProgressBar } from '../progressBar';
import {useUser} from "utils";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores/root";

export const ScanContainer: React.FC = observer(() => {
    const user = useUser()

    const {input: {text, activeSection}} = useStores();
    return (
        <div className='scan__container'>
            <div className="words__count">
                <ProgressBar
                    progress={text.length / (user?.words_per_generation_limit || 5000) * 100}
                />
                <div className="words">
                    {text.length} / {user?.words_per_generation_limit} characters
                </div>
            </div>
            <div className='scan-container__content'>
                <div className="scan-container__content">
                    <div className="s-circle human-written"></div>
                    <span>
                        {activeSection === "AI" ? "Human-written" : "Original"}
                    </span>
                </div>
                <div className="scan-container__content">
                    <div className="s-circle mixed"></div>
                    <span>Mixed</span>
                </div>
                <div className="scan-container__content">
                    <div className="s-circle ai-gen"></div>
                    <span>
                        {activeSection === "AI" ? "AI-generated" : "Plagiarized"}
                    </span>
                </div>
            </div>
        </div>
    );
})